import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import SectionLast from '../../components/sectionlast/SectionLast';
import { BASE_URL } from '../../../../utils/config';

function BlogDetail() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlogDetail = async () => {
            setLoading(true);
            setError(null);

            try {
                const res = await fetch(`${BASE_URL}view/blogs/${id}`);
                if (!res.ok) throw new Error('Blog not found');

                const data = await res.json();
                setBlog(data.data);
            } catch (err) {
                console.error("API error:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogDetail();
    }, [id]);

    if (loading) {
        return (
            <div className="min-h-screen bg-white flex items-center justify-center px-4">
                <p className="text-lg sm:text-xl text-gray-500">Loading blog post...</p>
            </div>
        );
    }

    if (error || !blog) {
        return (
            <div className="min-h-screen bg-white flex items-center justify-center px-4">
                <p className="text-lg sm:text-xl text-red-500 text-center">
                    Blog post not found or failed to load.
                </p>
            </div>
        );
    }

    return (
        <div className="bg-white min-h-screen mt-16 sm:mt-20">

            {/* ARTICLE Tag */}
            <div className="pt-8 sm:pt-10 pb-4 sm:pb-6 px-4 sm:px-6 max-w-5xl mx-auto">
                <span className="bg-purple-100 text-purple-700 text-xs font-semibold px-4 sm:px-6 py-1.5 sm:py-2 rounded">
                    ARTICLE
                </span>
            </div>

            {/* Title */}
            <div className="max-w-5xl mx-auto px-4 sm:px-6">
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tighter leading-tight text-[#111827]">
                    {blog.title}
                </h1>
            </div>

            {/* Meta: Author + Date + Share */}
            <div className="max-w-5xl mx-auto px-4 sm:px-6 mt-6 sm:mt-10 flex flex-wrap items-center gap-x-8 sm:gap-x-12 gap-y-5 sm:gap-y-6 pb-8 sm:pb-12 border-b border-gray-200">

                {/* Author */}
                <div className="flex items-center gap-3 sm:gap-4">
                    <div className="w-9 h-9 sm:w-11 sm:h-11 bg-[#0f0a2e] rounded-full flex items-center justify-center text-white text-lg sm:text-xl font-bold shrink-0">
                        E
                    </div>
                    <div>
                        <p className="text-xs sm:text-sm text-gray-500">Author</p>
                        <p className="text-sm sm:text-base font-semibold text-[#111827]">Element Us Labs</p>
                    </div>
                </div>

                {/* Date */}
                <div>
                    <p className="text-xs sm:text-sm text-gray-500">Date</p>
                    <p className="text-sm sm:text-base font-semibold text-[#111827]">
                        {new Date(blog.created_at).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                        })}
                    </p>
                </div>

                {/* Share Buttons */}
                <div>
                    <p className="text-xs sm:text-sm text-gray-500 mb-1.5 sm:mb-2">Share</p>
                    <div className="flex gap-4 sm:gap-5 text-xl sm:text-2xl text-gray-600">
                        <a href="#" className="hover:text-black transition-colors">𝕏</a>
                        <a href="#" className="hover:text-black transition-colors">in</a>
                        <a href="#" className="hover:text-black transition-colors">f</a>
                    </div>
                </div>
            </div>

            {/* Featured Image */}
            {blog.image && (
                <div className="max-w-5xl mx-auto px-4 sm:px-6 mt-8 sm:mt-12">
                    <img
                        src={blog.image}
                        alt={blog.title}
                        className="w-full rounded-2xl sm:rounded-3xl shadow-xl sm:shadow-2xl object-cover max-h-[300px] sm:max-h-[450px] lg:max-h-[560px]"
                    />
                </div>
            )}

            {/* Blog Content */}
            <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-10 sm:pt-16 pb-16 sm:pb-24">
                <div
                    className="prose prose-base sm:prose-lg max-w-none text-[#374151] leading-relaxed"
                    dangerouslySetInnerHTML={{
                        __html: blog.content.replace(/\r\n/g, '<br/><br/>')
                    }}
                />
            </div>

            {/* Back Button */}
            <div className="max-w-5xl mx-auto px-4 sm:px-6 pb-14 sm:pb-20">
                <Link
                    to="/blogs"
                    className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-700 font-medium text-base sm:text-lg transition-colors"
                >
                    ← Back to All Blogs
                </Link>
            </div>

            <SectionLast heading={'Get started with Element Us Labs'} />
        </div>
    );
}

export default BlogDetail;